/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import constant from '../../Global/Constant';
import Utility from '../../Global/Utility';

const rule: any = {
  full_name: [{
    required: true,
    message: constant.fullNameRequired,
  }, {
    type: 'string',
    pattern: /^[A-Za-z][A-Za-z .-]*$/,
    message: constant.splOrNumberOnlyError,
  }],
  email: [{
    required: true,
    message: constant.emailRequired,
  }, {
    type: 'email',
    message: constant.invalidEmail,
  }],
  phone: [
    {
      required: true,
      message: constant.phoneRequired,
    },
    {
      validator: Utility?.phoneOptionalValidator, // phone update
    },
  ],
};

export default rule;
